import firebase from "../../config/firebase";

export const getAdminEarnings =
  (onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("admin_earnings")
      .get()
      .then((query) => {
        dispatch({
          type: "ADMIN_EARNINGS",
          payload: query.docs[0].data(),
        });
        onComplete();
      });
  };

export const getRequiredPaypalAmount =
  (onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("wallet_stats")
      .get("totalWalletAmount")
      .then(async (query) => {
        let totalWalletAmount = 0;
        for await (let doc of query.docs) {
          totalWalletAmount = doc.data().totalWalletAmount;
        }
        dispatch({
          type: "SET_TOTAL_WALLET_AMOUNT",
          payload: totalWalletAmount,
        });
        onComplete();
      });
  };

export const getAthleteStats =
  (onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("stats")
      .doc("athletes_stats")
      .get()
      .then((query) => {
        dispatch({
          type: "GET_ATHLETES_STATS",
          payload: query.data(),
        });
        onComplete();
      });
  };
export const getFanStats =
  (onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("stats")
      .doc("fans_stats")
      .get()
      .then((query) => {
        dispatch({
          type: "GET_FANS_STATS",
          payload: query.data(),
        });
        onComplete();
      });
  };
export const getTotalIssues =
  (onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("stats")
      .doc("issues")
      .get()
      .then((query) => {
        dispatch({
          type: "GET_ISSUES_STATS",
          payload: query.data(),
        });
        onComplete();
      });
  };

export const getBoostEarnings =
  (onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const snapshot = await firebase
        .firestore()
        .collection("boost_transactions")
        .get();
      const total = snapshot.docs.reduce(
        (sum, doc) => sum + (doc.data().totalAmount || 0),
        0
      );
      dispatch({ type: "SET_BOOST_EARNINGS", payload: total });
    } catch (e) {
      console.error("Error fetching boost earnings:", e);
      dispatch({ type: "SET_BOOST_EARNINGS", payload: 0 });
    } finally {
      onComplete();
    }
  };
